export const COMPANY_NAME = 'The Neat Company'

export const APP_NAME = 'Scrooge'

export const URLS = {
  support: 'https://support.neat.com/',
  supportTicket: 'https://support.neat.com/support/create-case-pw/',
  termsAndConditions: 'https://www.neat.com/terms-conditions/',
  calendlyEvent: 'https://calendly.com/neatcompany/1-1-training?month=2022-08',
  bbbNeat: 'https://www.bbb.org/us/pa/phila/profile/computer-software/the-neat-company-inc-0241-45556105/#sealclick',
  vipService: 'https://www.neat.com/vip-service',
  automatedInsights: 'https://www.neat.com/automated-insights',
}

export const SCOPE = 'SSP'

export const SIDEBAR_ROUTES = {
  overview: '/overview',
  paymentMethod: '/payment-method',
  subscription: '/subscription',
  support: '/support',
}

export const ROUTES = {
  root: '/',
  auth: '/auth',
  ...SIDEBAR_ROUTES,
}

export const PLAN_SKU = {
  BASIC_ANNUAL_1200: 'b1200y',
  BASIC_MONTHLY_100: 'b100m',
  COMPLETE_100_MONTHLY_TRIAL: 'c100mt',
  COMPLETE_1200_ANNUAL_TRIAL: 'c1200yt',
  COMPLETE_ANNUAL_1200: 'c1200y',
  COMPLETE_ANNUAL_12000: 'c12000y',
  COMPLETE_ANNUAL_3000: 'c3000y',
  COMPLETE_MONTHLY_100: 'c100m',
  COMPLETE_MONTHLY_1000: 'c1000m',
  COMPLETE_MONTHLY_250: 'c250m',
  FILES_ANNUAL: 'nfunlyr',
  FILES_ANNUAL_LIMITED: 'nfbasyr',
  FILES_ANNUAL_TRIAL: 'nfunlyrt',
  FILES_MONTHLY: 'nfunlmo',
  FILES_NO_CC_TRIAL: 'nfunlft',
  NBOOKMO: 'nbookmo',
  NEAT_100_FREE_TRIAL: 'c100ft',
  NEAT_INVOICES: 'ninv',
  NEAT_MONTHLY: 'nmo',
  NEAT_NO_CC_TRIAL: 'nft',
  NEAT_YEARLY: 'nyr',
  NEAT_YEARLY_TRIAL: 'nyrt',
  NEATMO: 'neatmo',
  NEATVIPMPO: 'neatvipmo',
  NEATYRT: 'neatyrt',
  NEATYR: 'neatyr',
  NEATVIPYR: 'neatvipyr',
  NEATAIMO: 'neataimo',
  NEATAIVIPMO: 'neataivipmo',
  NEATAIYR: 'neataiyr',
  NEATAIVIPYR: 'neataivipyr',
  VAULT: 'vault',
  VAULT_50: 'vault50',
  NEAT_TEMP_ACCESS: 'neattmpaccess',
  NEAT_HOME: 'neathomeyr',
  NEAT_HOME_VIP: 'neathomevipyr',
  NEAT_HOME_NO_CC: 'neathomenocc',
  NEAT_DOCS_YEARLY: 'neatdocsyr',
}

export const COUNTRIES = {
  CA: 'Canada',
  US: 'United States',
  VI: 'Virgin Islands, U.S.',
  PR: 'Puerto Rico',
}

export const ZIP_CODE_REGEX_US = /^\d{5}(?:[-\s]\d{4})?$/

export const ZIP_CODE_REGEX_CA = /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/

export const SUPPORT_OPTIONS = {
  days: 'Monday - Friday',
  time: '9:00am - 8:00pm EST',
  phone: '(866) 632-8732',
  email: 'npotalivo@neat.com',
  manager: 'Nicole Potalivo',
}

export const SUBSCRIPTION_STATUSES = {
  ACTIVE: 'active',
  CANCELED: 'canceled',
  EXPIRED: 'expired',
  FAILED: 'failed',
  FUTURE: 'future',
  PAUSED: 'paused',
}

export const ACCOUNT_BILLING_STATUSES = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
  PAST_DUE: 'past_due',
  CANCELED: 'canceled',
}

export const CANCEL_RENEW_REASON = {
  REASON_TOO_EXPENSIVE: 'too_expensive',
  REASON_TOO_COMPLICATED: 'too_complicated',
  REASON_TECHNICAL_ISSUE: 'technical_issue',
  REASON_FOUND_ANOTHER_SOLUTION: 'found_another_solution',
  REASON_DID_NOT_MEET_MY_NEEDS: 'did_not_meet_my_needs',
}

export const TECHNICAL_ISSUE_TYPES = {
  SCANNER: 'Scanner Issue',
  WEBAPP: 'Web App Issue',
  MOBILE: 'Mobile App Issue',
  DESKTOP: 'Desktop Software Issue',
  OTHER: 'Other',
}

export const SOCKET_CHANNELS = {
  staypuft: 'staypuft',
}

export const EVENT_ACTIONS = {
  USER_DELETED: 'USER_DELETED',
}

export const EVENT_STATUSES = {
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  SUCCESS: 'SUCCESS',
}

export const INVOICE_STATUS = {
  PAST_DUE: 'past_due',
}

export const ORDER_ACTIVATION_TYPES = {
  NOW: 'now',
  RENEWAL: 'renewal',
}

export const TRANSITION_TYPE = {
  DOWNGRADED: 'downgraded',
  TRANSITIONED: 'transitioned',
}
